var _path, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_1",
    "data-name": 1,
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.161,
    height: 41.737,
    viewBox: "0 0 32.161 41.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M29.34,41.737V39.451h1.693v2.287Zm-27.647,0V39.451H3.386v2.287ZM1.2,39.451a1.2,1.2,0,0,1-1.2-1.2V1.2A1.2,1.2,0,0,1,1.2,0H30.961a1.2,1.2,0,0,1,1.2,1.2V38.251a1.2,1.2,0,0,1-1.2,1.2Z",
    fill: "#e1f4fb"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 25.54,
    height: 26.086,
    rx: 1.2,
    transform: "translate(3.784 6.166)",
    fill: "#fff",
    stroke: "#00a3da",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flame",
    transform: "translate(9.465 12.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M2.91,17.581A13.641,13.641,0,0,1,.578,14.275,7.516,7.516,0,0,1,.136,9.96a9.318,9.318,0,0,1,1.85-3.992A3.853,3.853,0,0,0,2.95,8.791,6.722,6.722,0,0,1,4.478,3.226,11.491,11.491,0,0,1,9.384,0,3.983,3.983,0,0,0,8.7,3.791,15.822,15.822,0,0,0,10.51,7.379a8.024,8.024,0,0,1,1.367,3.71,12.985,12.985,0,0,0,1.005-2.137,4.234,4.234,0,0,0,.161-2.339,6,6,0,0,1,1.327,2.9,12.237,12.237,0,0,1,.04,3.428,8.589,8.589,0,0,1-1.166,3.589,6.717,6.717,0,0,1-3.5,2.621A7.935,7.935,0,0,1,2.91,17.581Z",
    transform: "translate(0)",
    fill: "#00a3da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M2.657,10.928c3.3,1.29,6.554-2.621,4.745-5.645,0-.04-.04-.04-.04-.081A4.08,4.08,0,0,1,6.356,8.75a3.776,3.776,0,0,0-.362-3.065c-.483-.927-1.166-1.774-1.689-2.661A4.3,4.3,0,0,1,3.622,0a5.319,5.319,0,0,0-1.93,2.984,5.412,5.412,0,0,0,.4,3.549A2.652,2.652,0,0,1,1.008,4.6,4.159,4.159,0,0,0,0,7.379,4.106,4.106,0,0,0,2.657,10.928Z",
    transform: "translate(3.31 8.146)",
    fill: "#00a3da"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStove);
export default __webpack_public_path__ + "static/media/stove.bdbd20ec49aa1f3daa4f197ce5dd0ec1.svg";
export { ForwardRef as ReactComponent };